import { render, staticRenderFns } from "./ThanksMail.vue?vue&type=template&id=4a793c4a&scoped=true"
import script from "./ThanksMail.vue?vue&type=script&lang=js"
export * from "./ThanksMail.vue?vue&type=script&lang=js"
import style0 from "./ThanksMail.vue?vue&type=style&index=0&id=4a793c4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a793c4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a793c4a')) {
      api.createRecord('4a793c4a', component.options)
    } else {
      api.reload('4a793c4a', component.options)
    }
    module.hot.accept("./ThanksMail.vue?vue&type=template&id=4a793c4a&scoped=true", function () {
      api.rerender('4a793c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Modal/ThanksMail.vue"
export default component.exports